import { getProductImageUrl } from './productImage';
import { rubriqueCountKey } from './rubriqueCounts';

/** Palettes visuelles pour les tuiles menu POS (bordure + vignette si pas de photo). */
export const POS_MENU_PALETTES = [
  {
    border: 'border-orange-300',
    gradient: 'from-orange-500 via-amber-500 to-yellow-400',
    accent: 'text-orange-600',
  },
  {
    border: 'border-rose-300',
    gradient: 'from-rose-600 via-pink-500 to-fuchsia-500',
    accent: 'text-rose-600',
  },
  {
    border: 'border-emerald-300',
    gradient: 'from-emerald-600 via-teal-500 to-cyan-500',
    accent: 'text-emerald-600',
  },
  {
    border: 'border-violet-300',
    gradient: 'from-violet-600 via-purple-500 to-indigo-500',
    accent: 'text-violet-600',
  },
  {
    border: 'border-sky-300',
    gradient: 'from-sky-600 via-blue-500 to-indigo-400',
    accent: 'text-sky-600',
  },
  {
    border: 'border-amber-300',
    gradient: 'from-amber-600 via-orange-500 to-red-500',
    accent: 'text-amber-600',
  },
  {
    border: 'border-lime-300',
    gradient: 'from-lime-600 via-green-500 to-emerald-500',
    accent: 'text-lime-700',
  },
  {
    border: 'border-cyan-300',
    gradient: 'from-cyan-600 via-teal-500 to-blue-500',
    accent: 'text-cyan-600',
  },
];

export function getMenuTilePalette(index = 0) {
  return POS_MENU_PALETTES[Math.abs(index) % POS_MENU_PALETTES.length];
}

/** Première photo produit par catégorie / sous-catégorie + aperçu global. */
export function buildRubriqueCoverImages(produits = []) {
  const byCategorie = new Map();
  const bySousCategorie = new Map();
  const previewImages = [];

  produits.forEach((p) => {
    const img = getProductImageUrl(p);
    if (!img) return;

    if (previewImages.length < 4) {
      previewImages.push(img);
    }

    const catKey = rubriqueCountKey(p.categorie);
    if (catKey && !byCategorie.has(catKey)) {
      byCategorie.set(catKey, img);
    }

    const subKey = rubriqueCountKey(p.sousCategorie);
    if (catKey && subKey) {
      const fullKey = `${catKey}::${subKey}`;
      if (!bySousCategorie.has(fullKey)) {
        bySousCategorie.set(fullKey, img);
      }
    }
  });

  return { byCategorie, bySousCategorie, previewImages };
}
